

import React, { useState, useEffect, useRef, useMemo, } from "react";
import Cateringenquery from "../Component/Cateringenquery.js";
import Cateringall from "../Component/Cateringall";
import Cateringdeteals from "../Component/Cateringdeteals";
import { Link } from "react-router-dom";
import menu2 from "../Component/maamaaslog.png";
import Coustmizemenu from '../Component/Coustmizemenu';

import Catreingordercart from '../Component/Catreingordercart';
import CateringInvoice from '../Component/CateringInvoice';





const DATA = [
  // Starters
  { id: "it1", name: "Paneer Tikka", category: "starters", cuisine: "Indian", isVeg: true, price: 120 },
  { id: "it2", name: "Samosa", category: "starters", cuisine: "Indian", isVeg: true, price: 40 },
  { id: "it3", name: "Aloo Tikki", category: "starters", cuisine: "Indian", isVeg: true, price: 50 },
  { id: "it4", name: "Veg Pakora", category: "starters", cuisine: "Indian", isVeg: true, price: 60 },
  { id: "it5", name: "Spring Roll", category: "starters", cuisine: "Chinese", isVeg: true, price: 90 },
  { id: "it6", name: "Chili Paneer", category: "starters", cuisine: "Chinese", isVeg: true, price: 150 },
  { id: "it7", name: "Veg Manchurian", category: "starters", cuisine: "Chinese", isVeg: true, price: 110 },
  { id: "it8", name: "Hakka Noodles", category: "starters", cuisine: "Chinese", isVeg: true, price: 120 },
  { id: "it9", name: "Idli", category: "starters", cuisine: "South Indian", isVeg: true, price: 70 },
  { id: "it10", name: "Vada", category: "starters", cuisine: "South Indian", isVeg: true, price: 70 },
  { id: "it11", name: "Masala Dosa", category: "starters", cuisine: "South Indian", isVeg: true, price: 120 },
  { id: "it12", name: "Medu Vada", category: "starters", cuisine: "South Indian", isVeg: true, price: 80 },
  { id: "it13", name: "Chicken Tikka", category: "starters", cuisine: "Indian", isVeg: false, price: 180 },
  { id: "it14", name: "Fish Fry", category: "starters", cuisine: "Indian", isVeg: false, price: 200 },
  { id: "it15", name: "Mutton Seekh Kebab", category: "starters", cuisine: "Indian", isVeg: false, price: 220 },

  // Mains
  { id: "it16", name: "Butter Naan", category: "mains", cuisine: "Indian", isVeg: true, price: 30 },
  { id: "it17", name: "Paneer Butter Masala", category: "mains", cuisine: "Indian", isVeg: true, price: 180 },
  { id: "it18", name: "Dal Makhani", category: "mains", cuisine: "Indian", isVeg: true, price: 150 },
  { id: "it19", name: "Fried Rice", category: "mains", cuisine: "Chinese", isVeg: true, price: 130 },
  { id: "it20", name: "Chowmein", category: "mains", cuisine: "Chinese", isVeg: true, price: 120 },
  { id: "it21", name: "Garlic Chicken", category: "mains", cuisine: "Chinese", isVeg: false, price: 200 },

  // Desserts
  { id: "it22", name: "Gulab Jamun", category: "desserts", cuisine: "Indian", isVeg: true, price: 60 },
  { id: "it23", name: "Rasmalai", category: "desserts", cuisine: "Indian", isVeg: true, price: 90 },
  { id: "it24", name: "Brownie", category: "desserts", cuisine: "Continental", isVeg: true, price: 110 },
  { id: "it25", name: "Ice Cream Scoop", category: "desserts", cuisine: "Continental", isVeg: true, price: 70 },

  // Soft Drinks
  { id: "it26", name: "Coke", category: "softdrinks", cuisine: "Beverage", isVeg: true, price: 40 },
  { id: "it27", name: "Pepsi", category: "softdrinks", cuisine: "Beverage", isVeg: true, price: 40 },
  { id: "it28", name: "Sprite", category: "softdrinks", cuisine: "Beverage", isVeg: true, price: 40 },

  // Beverages
  { id: "it29", name: "Masala Chai", category: "beverages", cuisine: "Hot", isVeg: true, price: 30 },
  { id: "it30", name: "Coffee", category: "beverages", cuisine: "Hot", isVeg: true, price: 50 },
  { id: "it31", name: "Cold Coffee", category: "beverages", cuisine: "Cold", isVeg: true, price: 90 },
  { id: "it32", name: "Iced Tea", category: "beverages", cuisine: "Cold", isVeg: true, price: 80 },
  { id: "it33", name: "Mango Shake", category: "beverages", cuisine: "Cold", isVeg: true, price: 100 },
];

const CATEGORIES = [
  { key: "starters", label: "Starters" },
  { key: "mains", label: "Mains" },
  { key: "desserts", label: "Desserts" },
  { key: "softdrinks", label: "Soft Drinks" },
  { key: "beverages", label: "Beverages" },
];

const CUISINES = ["Indian", "Chinese", "South Indian", "Continental", "Beverage", "Hot", "Cold"];
const EVENTS = ["Wedding", "Birthday", "Corporate", "Anniversary", "Bachelor", "House Party"];
const BUDGETS = [
  { key: "lt100", label: "Below ₹100", match: (p) => p < 100 },
  { key: "100to200", label: "₹100 – ₹200", match: (p) => p >= 100 && p <= 200 },
  { key: "gt200", label: "Above ₹200", match: (p) => p > 200 },
];

const TabComponent = () => {
  const [activeTab, setActiveTab] = useState("enquiry");
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showTableBookingModal, setShowTableBookingModal] = useState(false);



  const [eventTypes, setEventTypes] = useState([]);
  const [cuisineTypes, setCuisineTypes] = useState([]);
  const [mealType, setMealType] = useState("mixed"); // veg | nonveg | mixed
  const [activeCategories, setActiveCategories] = useState(CATEGORIES.map(c => c.key)); // show all by default
  const [budgetKey, setBudgetKey] = useState(""); // selects a budget band

  // UI state
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Selection with quantities
  const [cart, setCart] = useState({}); // { [id]: { item, qty } }

  // Derived totals
  const totalItems = useMemo(
    () => Object.values(cart).reduce((s, r) => s + r.qty, 0),
    [cart]
  );
  const totalAmount = useMemo(
    () => Object.values(cart).reduce((s, r) => s + r.qty * r.item.price, 0),
    [cart]
  );

  // Helpers
  const toggleEvent = (e) =>
    setEventTypes((prev) => (prev.includes(e) ? prev.filter((x) => x !== e) : [...prev, e]));

  const toggleCuisine = (c) =>
    setCuisineTypes((prev) => (prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]));

  const toggleCategory = (key) =>
    setActiveCategories((prev) =>
      prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
    );

  const visibleItems = useMemo(() => {
    return DATA.filter((it) => {
      // Category
      if (!activeCategories.includes(it.category)) return false;

      // Cuisine (if any selected)
      if (cuisineTypes.length && !cuisineTypes.includes(it.cuisine)) return false;

      // Meal type
      if (mealType === "veg" && !it.isVeg) return false;
      if (mealType === "nonveg" && it.isVeg) return false;

      // Budget
      const band = BUDGETS.find((b) => b.key === budgetKey);
      if (band && !band.match(it.price)) return false;

      // Search
      if (search.trim()) {
        const s = search.toLowerCase();
        if (!(`${it.name} ${it.cuisine} ${it.category}`.toLowerCase().includes(s))) return false;
      }
      return true;
    });
  }, [activeCategories, cuisineTypes, mealType, budgetKey, search]);

  const isSelected = (id) => !!cart[id];

  const toggleItem = (item) => {
    setCart((prev) => {
      const next = { ...prev };
      if (next[item.id]) {
        // unselect
        delete next[item.id];
      } else {
        next[item.id] = { item, qty: 1 };
      }
      return next;
    });
  };

  const incQty = (id) =>
    setCart((prev) => ({ ...prev, [id]: { ...prev[id], qty: prev[id].qty + 1 } }));

  const decQty = (id) =>
    setCart((prev) => {
      const q = prev[id].qty - 1;
      const next = { ...prev };
      if (q <= 0) delete next[id];
      else next[id] = { ...prev[id], qty: q };
      return next;
    });

  const selectAllVisible = () => {
    setCart((prev) => {
      const next = { ...prev };
      visibleItems.forEach((it) => {
        if (!next[it.id]) next[it.id] = { item: it, qty: 1 };
      });
      return next;
    });
  };

  // const clearAll = () => setCart({});

  const scrollContainerRef = useRef(null);

  const orderPosts = [
    { dishId: 1, orderType: "Dine-In" },
    { dishId: 2, orderType: "Take Away" },
    { dishId: 3, orderType: "Delivery" },
  ];

  // Auto-scroll for right panel
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval = setInterval(() => {
      if (!isHovered) {
        scrollContainer.scrollTop += 1;
        if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
          scrollContainer.scrollTop = 0;
        }
      }
    }, 20);

    return () => clearInterval(interval);
  }, [isHovered]);

  // Mobile resize check
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const clearAll = () => {
    setCuisineTypes([]);        // saare cuisine unselect
    setMealType("");            // meal type reset
    setActiveCategories([]);    // categories clear
  };

  return (
    <div className="container-fluid " style={{ marginTop: "35px" }}>

      <style>{`
        .no-scrollbar { scrollbar-width: none; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .tag { font-size: 12px; padding: 2px 6px; border-radius: 999px; }
        .tag-veg { background:#e8f7ec; color:#1f7a3a; border:1px solid #bfe8cb; }
        .tag-nonveg { background:#ffecec; color:#b00020; border:1px solid #ffc5c5; }
        .pill {  padding:6px 0px; border-radius:8px; display:inline-block; margin:4px 6px 0 0; font-size:13px; }
        .btn { padding:10px 12px; border:none; border-radius:8px; cursor:pointer; font-weight:600; }
        .btn-primary { background:#6c47ff; color:#fff; }
        .btn-ghost { background:#eee; }
        .btn-green { background:#28a745; color:#fff; }
        .btn-danger { background:#ff4d4f; color:#fff; }
        @media (max-width: 992px) {
          .layout { flex-direction: column; }
        }
      `}</style>


      <div className="row">
        {/* <p
          className="breadcrumb maamaas-home-bredcumsyy"
          style={{
            position: "fixed",
            top: "63px",
            left: '191px',
            width: "100%",
            backgroundColor: "#fff",
            zIndex: 1000,
            padding: "10px 0",
            fontSize: "18px",
            fontWeight: "bold",
            textAlign: "center",
            margin: 0,
          }}
        >
          <Link
            to="/"
            style={{
              color: "purple",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Home
          </Link>
          <span className="separator"> &gt; </span>
          <Link
            to="/Catreningitem"
            style={{
              color: "purple",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Catering
          </Link>


        </p> */}
       
        {/* <aside style={styles.sidebar} className="no-scrollbar">

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={styles.heading}>Filters</h3>
            <button
              className="btn btn-danger"
              style={styles.clearButton}
              onClick={clearAll}
            >
              Clear All
            </button>
          </div>

          
          <div style={styles.filterBlock}>
            <div style={styles.filterTitle}>Cuisine</div>
            <div style={styles.filterOptions}>
              {CUISINES.map((c) => (
                <label key={c} style={styles.optionRow}>
                  <input
                    type="checkbox"
                    checked={cuisineTypes.includes(c)}
                    onChange={() => toggleCuisine(c)}
                    style={styles.checkbox}
                  />
                  {c}
                </label>
              ))}
            </div>
          </div>

         
          <div style={styles.filterBlock}>
            <div style={styles.filterTitle}>Meal Type</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {["mixed", "veg", "nonveg"].map((t) => (
                <label
                  key={t}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: mealType === t ? "bold" : "normal",
                    color: mealType === t ? "#6c47ff" : "#333",
                  }}
                >
                 
                  <input
                    type="checkbox"
                    checked={mealType === t}
                    onChange={() => setMealType(t)}
                    style={{ accentColor: "#6c47ff", cursor: "pointer" }}
                  />

                 
                  {t === "mixed" ? "Mixed" : t === "veg" ? "Veg" : "Non-Veg"}
                </label>
              ))}
            </div>

          </div>


          
          <div style={styles.filterBlock}>
            <div style={styles.filterTitle}>Categories</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {CATEGORIES.map((cat) => (
                <label
                  key={cat.key}
                  className=""
                  style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    checked={activeCategories.includes(cat.key)}
                    onChange={() => toggleCategory(cat.key)}
                    style={{
                      marginRight: 8,
                      accentColor: "#6c47ff",
                      width: "13px",   // ✅ width fixed
                      height: "13px",  // ✅ height fixed
                    }}
                  />
                  {cat.label}
                </label>
              ))}
            </div>
          </div>


        </aside> */}


        {/* Main Content */}
        {/* <div className="col-lg-7 col-md-6 col-sm-12 mb-3"> */}



          <div
            className="card"
            style={{ height: "650px", borderRadius: "8px", overflow: "hidden", border: 'none', }}
          >
            {/* Tab Buttons */}
            <div className="d-flex justify-content-center" style={{marginBottom:"20px"}}>
              <button
                style={activeTab === "enquiry" ? styles.btnActive : styles.btnOutline}
                className="mx-2"
                onClick={() => setActiveTab("enquiry")}
              >
                Event Details
              </button>

              <button
                style={activeTab === "menu" ? styles.btnActive : styles.btnOutline}
                className="mx-2"
                onClick={() => setActiveTab("menu")}
              >
               Coustmizemenu
              </button>

              {/* <button
                style={activeTab === "Coustmizemenu" ? styles.btnActive : styles.btnOutline}
                className="mx-2"
                onClick={() => setActiveTab("Coustmizemenu")}
              >
                Coustmizemenu
              </button> */}

              {/* <button
                style={activeTab === "Catreingordercart" ? styles.btnActive : styles.btnOutline}
                className="mx-2"
                onClick={() => setActiveTab("Catreingordercart")}
              >
                Review_Order
              </button>
              <button
                style={activeTab === "CateringInvoice" ? styles.btnActive : styles.btnOutline}
                className="mx-2"
                onClick={() => setActiveTab("CateringInvoice")}
              >
                PayOuts
              </button> */}
            </div>



            {/* Tab Content */}
            <div
              className="p-3"
              style={{ overflowY: "auto", height: "550px", scrollbarWidth: "none" }}
            >
              {activeTab === "enquiry" && (
                <Cateringenquery onNext={() => setActiveTab("menu")} />
              )}
              {activeTab === "details" && (
                <Cateringdeteals onNext={() => setActiveTab("menu")} />
              )}
              {activeTab === "menu" && (
                <Coustmizemenu onNext={() => setActiveTab("Coustmizemenu")} />
              )}
              {/* {activeTab === "Coustmizemenu" && <Coustmizemenu />} */}

              {/* {activeTab === "Coustmizemenu" && (
                <Coustmizemenu onNext={() => setActiveTab("Catreingordercart")} />
              )} */}
              {/* {activeTab === "Catreingordercart" && 
              <Catreingordercart onNext={() => setActiveTab("CateringInvoice")} />} */}
              {/* {activeTab === "CateringInvoice" && <CateringInvoice />} */}
            </div>


          </div>
        </div>

        {/* Right Slider */}
        {/* <div className="col-lg-3 d-none d-lg-block">
          <div
            className="card"
            style={{
              height: "650px",
              border: 'none',

              borderRadius: "8px",
              padding: "10px",
              overflow: "hidden",
            }}
          >
            <div
              ref={scrollContainerRef}
              style={{
                maxHeight: "650px",
                overflowY: "auto",
                paddingRight: "5px",
                scrollbarWidth: "none",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {orderPosts.concat(orderPosts).map((post, index) => (
                <div
                  key={`${post.dishId}-${index}`}
                  className="card mb-3 text-center text-white"
                  style={{
                    background: "#9937caff",
                    borderRadius: "8px",
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h6>{post.orderType}</h6>
                  <button className="btn btn-sm btn-light fw-bold mt-2">
                    Add to cart
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    // </div>



  );
};


const styles = {
  page: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: "#fafafa",
    minHeight: "100vh",
    marginTop: "50px",
    paddingBottom: 24,
  },
  breadcrumbWrap: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "#fff",
    padding: "10px 16px",
    borderBottom: "1px solid #eee",
    display: "flex",
    alignItems: "center",
  },
  breadcrumbLink: { color: "#ee6521", textDecoration: "none", fontWeight: 600 },

  container: {
    marginTop: 12,
    display: "flex",
    gap: 16,
    padding: "12px 16px",
  },

  sidebar: {
    flex: "2",
    minWidth: 240,
    maxHeight: "78vh",
    overflowY: "auto",
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  itemsSection: {
    flex: "7",
    minWidth: 320,
    maxHeight: "78vh",
    overflowY: "auto",
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },
  selectedSection: {
    flex: "3",
    minWidth: 260,
    maxHeight: "78vh",
    overflowY: "auto",
    // background: "#f7faff",
    // border: "1px solid #e5edff",
    borderRadius: 12,
    padding: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },

  heading: { fontSize: 18, fontWeight: 700, marginBottom: 8, color: "#222" },

  filterBlock: { marginBottom: 14 },
  filterTitle: { fontWeight: 700, marginBottom: 6 },
  filterOptions: { display: "flex", flexDirection: "column", gap: 6 },
  filterOptionsRowWrap: { display: "flex", flexWrap: "wrap", gap: 6 },
  filterChips: { display: "flex", gap: 8, flexWrap: "wrap" },

  optionRow: { display: "flex", alignItems: "center", gap: 8 },
  checkbox: { width: 13, height: 13, accentColor: "#28a745" },
  radio: { width: 16, height: 16, accentColor: "#ee6521" },

  itemsHeader: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  search: {
    flex: 1,
    maxWidth: 360,
    border: "1px solid #e1e1e1",
    borderRadius: 8,
    padding: "10px 12px",
    outline: "none",
  },

  itemsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: 12,
  },
  card: {
    // border: "1px solid #eee",
    borderRadius: 12,
    padding: 12,
    // background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  },
  cardTopRow: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 },
  itemName: { fontWeight: 600 },

  metaRow: { display: "flex", gap: 6, flexWrap: "wrap" },
  metaBadge: {
    background: "#f4f4f5",
    color: "#555",
    fontSize: 12,
    padding: "3px 8px",
    borderRadius: 999,
    // border: "1px solid #eee",
  },

  priceRow: { display: "flex", alignItems: "center", justifyContent: "space-between" },
  price: { fontWeight: 700 },

  qtyRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "#f6f6ff",
    borderRadius: 999,
    padding: "4px 6px",
    border: "1px solid #e9e7ff",
  },
  qtyBtn: {
    width: 28,
    height: 28,
    borderRadius: 8,
    border: "1px solid #d8d6ff",
    background: "#fff",
    cursor: "pointer",
    fontWeight: 700,
  },
  qtyVal: { minWidth: 20, textAlign: "center", fontWeight: 700 },

  actionBar: {
    marginTop: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 8,
    borderTop: "1px solid #eee",
  },

  selectedList: { display: "flex", flexDirection: "column", gap: 8, flex: 1, overflowY: "auto" },
  selectedRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px",
    border: "1px solid #e6ecff",
    background: "#fff",
    borderRadius: 10,
  },
  selectedQty: { display: "flex", alignItems: "center", gap: 6 },
  qtyBtnMini: {
    width: 24, height: 24, borderRadius: 6, border: "1px solid #d8d6ff", background: "#fff", cursor: "pointer",
  },
  qtyValMini: { minWidth: 18, textAlign: "center", fontWeight: 700 },

  totalsBox: {
    marginTop: 10,
    border: "1px dashed #cdd6ff",
    borderRadius: 12,
    padding: 10,
    background: "#f8f9ff",
  },
  totalLine: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 },

  rightButtons: { marginTop: 10, display: "flex", gap: 8 },

  modalOverlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16,
  },
  modalContent: {
    background: "#fff", width: "min(720px, 96vw)", maxHeight: "86vh",
    borderRadius: 16, padding: 16, overflowY: "auto", boxShadow: "0 8px 28px rgba(0,0,0,0.25)",
  },
  modalList: { display: "flex", flexDirection: "column", gap: 10 },
  modalItem: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "10px 12px", border: "1px solid #eee", borderRadius: 12, background: "#fafafa",
  },
  modalPrice: { fontWeight: 700, minWidth: 64, textAlign: "right" },
  modalTotals: {
    marginTop: 12, paddingTop: 10, borderTop: "1px solid #eee",
    display: "flex", flexDirection: "column", gap: 6,
  },
  modalButtonsRow: {
    marginTop: 12, display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap",
  },

  clearButton: {
    padding: "6px 10px",
    fontSize: "13px",
    background: "#b74bcdff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },

  btnActive: {
    backgroundColor: "#ee6521",
    color: "white",
    border: "1px solid brown",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
  },
  btnOutline: {
    backgroundColor: "transparent",
    color: "#ac59bfff",
    border: "1px solid #cb69ceff",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
  },
};
export default TabComponent;
